export default __webpack_public_path__ + "static/media/1.c4ff0317.png";